import axios from 'axios'

// Blob error bodies need decoding to show the server's message
const errorMessage = async (error) => {
  const data = error.response?.data
  if (data instanceof Blob) {
    try {
      return JSON.parse(await data.text()).message || error.message
    } catch {
      return error.message
    }
  }
  return data?.message || error.message
}

const filenameFrom = (disposition, fallback) => {
  const match = /filename="?([^";]+)"?/i.exec(disposition || '')
  return match ? match[1] : fallback
}

// Fetches with the session cookie, then saves the response as a file
export const downloadFile = async (url, params, fallbackName) => {
  axios.defaults.withCredentials = true

  try {
    const response = await axios.get(url, { params, responseType: 'blob' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(response.data)
    link.download = filenameFrom(
      response.headers['content-disposition'],
      fallbackName
    )
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(link.href)
  } catch (error) {
    throw new Error(await errorMessage(error))
  }
}

export { filenameFrom }
